export const START_BACKEND_API_CALL = 'START_BACKEND_API_CALL';
export const FINISH_BACKEND_API_CALL = 'FINISH_BACKEND_API_CALL';
export const START_SUBMIT_CHANGES_API_CALL = 'START_SUBMIT_CHANGES_API_CALL';
export const SUCCESS_SUBMIT_CHANGES_API_CALL = 'SUCCESS_SUBMIT_CHANGES_API_CALL';
export const SHOW_404 = 'SHOW_404';